import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faVideo, faArrowLeft, faArrowRight, faMagnifyingGlassPlus,
  faMagnifyingGlassMinus, faRotate, faPersonWalking, faArrowUp,
} from "@fortawesome/free-solid-svg-icons";

// Préréglages de mouvement caméra — ajoutés au prompt au moment de la
// génération (le modèle vidéo n'a pas de paramètre dédié, on le pilote par texte).
export const MOTION_PRESETS = [
  { key: "static",    label: "Plan fixe",         icon: faVideo,                  directive: "camera fixe, plan statique" },
  { key: "pan-left",  label: "Panoramique ←",      icon: faArrowLeft,              directive: "la caméra effectue un panoramique lent vers la gauche" },
  { key: "pan-right", label: "Panoramique →",      icon: faArrowRight,             directive: "la caméra effectue un panoramique lent vers la droite" },
  { key: "zoom-in",   label: "Zoom avant",         icon: faMagnifyingGlassPlus,    directive: "la caméra zoome lentement vers l'avant" },
  { key: "zoom-out",  label: "Zoom arrière",       icon: faMagnifyingGlassMinus,   directive: "la caméra recule lentement, zoom arrière" },
  { key: "orbit",     label: "Orbite",             icon: faRotate,                 directive: "la caméra tourne lentement autour du sujet, mouvement orbital" },
  { key: "handheld",  label: "Caméra épaule",      icon: faPersonWalking,          directive: "mouvement de caméra à l'épaule, léger tremblement naturel" },
  { key: "crane-up",  label: "Grue ↑",             icon: faArrowUp,                directive: "mouvement de grue, la caméra s'élève lentement" },
];

export const motionDirective = (key) => MOTION_PRESETS.find((m) => m.key === key)?.directive || "";

const MotionControlPicker = ({ value, onChange }) => (
  <div>
    <p className="text-xs font-semibold text-gray-500 mb-2">Motion control</p>
    <div className="flex gap-2 flex-wrap">
      <button
        onClick={() => onChange(null)}
        className={`px-3 py-1.5 rounded-lg text-xs font-medium border ${!value ? "bg-[#221C51] text-white border-[#221C51]" : "border-gray-200 text-gray-500 hover:border-gray-300"}`}
      >
        Aucun
      </button>
      {MOTION_PRESETS.map((m) => (
        <button
          key={m.key}
          onClick={() => onChange(value === m.key ? null : m.key)}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium border transition ${
            value === m.key ? "bg-fuchsia-600 text-white border-fuchsia-600" : "border-gray-200 text-gray-600 hover:border-gray-300"
          }`}
        >
          <FontAwesomeIcon icon={m.icon} className="text-[11px]" />
          {m.label}
        </button>
      ))}
    </div>
  </div>
);

export default MotionControlPicker;
